<template>
  <!-- 直播倒计时 -->
  <div class="goto_live" @click="LinkAct(info)">
    <img v-if="info.company.logo" :src="info.company.logo" v-load="'oPicXS'" />
    <img v-else-if="exhibitionInfo && exhibitionInfo.exhibition && exhibitionInfo.exhibition.logo" :src="exhibitionInfo.exhibition.logo" v-load="'oPicXS'" />
    <img v-else src="@assets/img/empty.png" />
    <p>Live</p>
    <div class="go_look">Go</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "goto-live",
  props: {
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      isLive: false,
      shortLiveInfo: {},
    };
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "company/getExhibitionInfo",
      exhibitorId: "company/getExhibitorId",
    }),
  },
  created() {},
  methods: {
    ...mapActions({
      LinkAct: "linkTo/LinkAct",
    }),

    //是否正在直播
    async getliveInfo() {
      if (res) {
        this.shortLiveInfo = res;
        let startDate = this.shortLiveInfo.startTime.replace(/\-/g, "/");
        let endDate = this.shortLiveInfo.endTime.replace(/\-/g, "/");
        const strTime = new Date(startDate).getTime();
        const now = new Date().getTime();
        const endTime = new Date(endDate).getTime();
        if (strTime < now && now < endTime) {
          this.isLive = true;
        }
      }
    },
    //点击去看直播
    goToLive() {
      console.log("看直播");
      // this.LinkExhibitionLive(this.shortLiveInfo.autoId);
    },
  },
};
</script>

<style scoped lang="scss">
.goto_live {
  height: 1.6rem;
  width: 0.96rem;
  background: rgba(0, 0, 0, 0.35);
  padding: 0.2rem 0 0.05rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 0.2rem;
  justify-content: space-between;
  color: #fff;
  img {
    width: 0.44rem;
    height: 0.44rem;
    border-radius: 50%;
    // object-fit: cover;
  }
  p {
    font-size: 0.2rem;
  }
  .go_look {
    font-size: 0.2rem;
    width: 0.8rem;
    height: 0.35rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%);
    border-radius: 0.18rem;
  }
}
</style>
